import { Injectable } from '@angular/core';

@Injectable()
export class AppConfigService {
  appName: string;
  website: string;
  company: string;
  tel: string;
  api: string;
  hasLianlianPay: boolean;
  shareLink: string;
  wechatId: string;
  alipayAccount: string;
  alipayQrcode: string;
  alipayName: string;

  constructor() {
    this.initConfig('icac');
  }

  initConfig(appShorthand: string): void {
    switch (appShorthand) {
      case 'icac':
        this.appName = 'Icac';
        this.tel = '4006963127';
        this.api = 'https://www.chinaicac.org/icac';
        // this.api = 'http://10.0.20.207:8080';
        // this.api = 'http://chinaicac.dev.carlinx.cn/icac'; // 测试环境
        // this.api = 'http://192.168.0.36:8080/icac_manage_controller_war_exploded'; // 测试环境
        
        break;
      default:
        break;
    }
  }

}



// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/service/app-config.service.ts